import styled, { keyframes } from 'styled-components';

import colors from 'app/styles/theme/colors';
import {
  radii,
  spacing,
  fontSizes,
  fontFamily,
} from 'app/components/customers/styles/scales';
import { rgba } from 'app/components/customers/styles/rgba';

const { gray, red } = colors.designSystem;

const slideUp = keyframes`
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
`;

export const ErrorToastContainer = styled.div`
  position: fixed;
  bottom: ${spacing[24]};
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  display: flex;
  align-items: flex-start;
  gap: ${spacing[10]};
  width: calc(100% - ${spacing[24]});
  max-width: 480px;
  padding: ${spacing[12]} ${spacing[16]};
  border: 1px solid ${rgba(red[500], 0.3)};
  border-left: 4px solid ${red[500]};
  border-radius: ${radii.medium};
  background: ${red[50]};
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  font-family: ${fontFamily.body};
  animation: ${slideUp} 0.25s ease-out;
`;

export const ErrorToastIcon = styled.span`
  color: ${red[500]};
  font-size: ${fontSizes[14]};
  line-height: 1;
`;

export const ErrorToastMessage = styled.span`
  flex: 1;
  color: ${gray[950]};
  font-size: ${fontSizes[13]};
  line-height: 1.4;
`;

export const ErrorToastCloseButton = styled.button`
  padding: 0;
  border: none;
  background: none;
  color: ${gray[700]};
  font-size: ${fontSizes[13]};
  line-height: 1;
  cursor: pointer;
  transition: color 0.15s;

  &:hover {
    color: ${gray[950]};
  }
`;
